import { render, staticRenderFns } from "./MarketingCard.vue?vue&type=template&id=89922e56"
import script from "./MarketingCard.vue?vue&type=script&lang=ts"
export * from "./MarketingCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports